import { gql } from '@apollo/client';

export const SET_LAST_CHANGELOG_SEEN = gql`
  mutation SetLastChangelogSeen {
    setLastChangelogSeen {
      id
      lastChangelogSeen
    }
  }
`;
